
export class DisplayLabel {
    id: number;
    label: string;
    color: string;
    passwordCount: number;
}